export type PlaylistMode = 'mos' | 'default';

export function getPlaylistMode(playlist: Playlist | undefined): PlaylistMode {
  if (!playlist?.externalReference) return 'default';

  switch (true) {
    case playlist.externalReference.startsWith('mos_'):
      return 'mos';
    default:
      return 'default';
  }
}
